export default "__VITE_ASSET__6cfc32d2__"